import React, { Component } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Localization } from "../../common/Localization";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import TovarFoto from "../../common/TovarFoto";
import { prijemBalikaController } from "../../../controllers/prijembalika.controller";
import confirmService from "../../common/confirmService";
import { Zvuky } from "../../common/Zvuky";

class PolozkaBezKoduVyberDialogContent extends Component {
    state = {
        selectedIdVariant: this.props.response.polozky[0].idVariant,
        selectedVelikostId: 1
    };

    pridatKus = () => {
        prijemBalikaController.pridatKusBezCiarovehoKodu(this.props.balik, this.state.selectedIdVariant, this.state.selectedVelikostId).then(async response => {
            if (response.isError) {
                Zvuky.playChyba();
                await confirmService.show({
                    message: response.errorMessage
                });
                return;
            }
            this.props.pridatKus(response);
        });
        this.props.toggleDialog();
    };

    render() {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="PolozkaBezKoduVyberDialog">
                <div className="row">
                    <div className="col-xs-5">
                        <TovarFoto idVariant={this.state.selectedIdVariant} idKarta={null} />
                    </div>
                    <div className="col-xs-7">
                        <div className="alert alert-warning nadpis" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            {this.props.response.nazovArtikla}
                        </div>
                        <div className="row">
                            <div className="col-xs-6">
                                <Grid
                                    style={{ height: "220px" }}
                                    data={this.props.response.polozky.map(item => ({ ...item, selected: item.idVariant === this.state.selectedIdVariant }))}
                                    selectedField="selected"
                                    onRowClick={e => {
                                        this.setState({
                                            selectedIdVariant: e.dataItem.idVariant
                                        });
                                    }}>
                                    <Column field="nazov" title={localizationService.toLanguageString("PríjemBezKódu.Farby", "Farby")} />
                                </Grid>
                            </div>
                            <div className="col-xs-6">
                                <Grid
                                    style={{ height: "220px" }}
                                    data={this.props.response.velikosti.map(velikost => ({
                                        ...velikost,
                                        selected: velikost.item1 === this.state.selectedVelikostId
                                    }))}
                                    selectedField="selected"
                                    onRowClick={e => {
                                        this.setState({
                                            selectedVelikostId: e.dataItem.item1
                                        });
                                    }}>
                                    <Column field="item2" title={localizationService.toLanguageString("PríjemBezKódu.Veľkosti", "Veľkosti")} />
                                </Grid>
                            </div>
                        </div>
                        <Button className="font-bold" onClick={this.pridatKus} style={{ marginTop: "15px" }}>
                            <Localization messageKey={"PríjemBezKódu.Pridať do balíka"} defaultMessage={"Pridať do balíka"} />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default PolozkaBezKoduVyberDialogContent;

registerForLocalization(PolozkaBezKoduVyberDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijemBalika/PolozkaBezKoduVyberDialogContent.js